import React, { useState } from 'react'
import AddNewCalculation from '../components/AddNewCalculation';
import KitchensList from '../assets/kitchensList.json'
import { Replay } from '@material-ui/icons';
import { db } from '../config/fbConfig'
import { collection, addDoc } from 'firebase/firestore'
import { getProject } from '../services/getProject.service';
import '../app.css';




const HomeScreen = () => {

  const [state, setState] = useState({
    projectId: '',
    kitchenType: '',
    selectActive: false,
    projectIdByUser: false,
    showProjectId: false,
    showCalculator: false,
    error: false,
    project: {},
    copyText: 'Kopiera Kod'

  })
  const setProjectId = (e) => {
    const newValue = e.target.value
    setState({ ...state, projectId: newValue })
  }

  const getDataFromDB = async (e) => {
    e.preventDefault();
    const data = await getProject(state.projectId)
    if (data === 'error') {
      return setState({
        ...state, error: true
      })
    }
    return setState({
      ...state, project: data, showCalculator: true, kitchenType: data.name, selectActive: true,
      projectIdByUser: true, showProjectId: true
    })
  }

  const handleChange = async (event) => {
    let name = event.target.value
    const docRef = await addDoc(collection(db, 'projects'), {
      name: event.target.value
    })
    setState({
      ...state, projectId: docRef.id, kitchenType: name,
      selectActive: true, showCalculator: true, showProjectId: true, projectIdByUser: true,
    });
  };

  const clear = () => {
    setState({
      ...state,
      kitchenType: '',
      selectActive: false,
      showCalculator: false,
      projectIdByUser: false,
      showProjectId: false,
      projectId: ''
    })
  }


  const copy = (text) => {
    navigator.clipboard.writeText(text);
    setState({ ...state, copyText: 'KOPIERAD' })
    setTimeout(() => setState({ ...state, copyText: 'Kopiera kod' }), 2000)
  };




  return (
    <div className="App">
      <form>
        {!state.projectIdByUser && <div className='open-project'>
          <input required className='open-projectId-input' onChange={setProjectId} value={state.projectId} type='text' placeholder='Projekt kod' ></input>
          <button className='open-projectId-btn' onClick={getDataFromDB}>Öppna</button>
          {state.error && <p style={{ color: 'red' }}>Ingen projekt hittades</p>}
        </div>}

        <div style={{ display: 'flex', marginBottom: '30px' }}>
          <div className='kitchen-select-container'>
            <span className='kitchenSelect-label'><p>Typ av Kök</p></span>
            <select value={state.kitchenType} onChange={handleChange} className={'kitchens-list'} disabled={state.selectActive}>
              <option value='' >Välj typ av kök</option>
              {KitchensList.map((opt, i) => <option value={opt} key={i}>{opt}</option>)}
            </select>
          </div>
          <div onClick={clear} className='reset-container'>
            <span><Replay /></span>
            <p>Återställ</p>
          </div>

        </div>
        {state.showProjectId && <div className='projectId-container'>
          <span className='projectId-label'><p>Projekt kod </p></span>
          <span className='projectId-p'><p className='print'>Referens:</p><p>{state.projectId}</p></span>
          <span className='projectId-label copy' onClick={() => copy(state.projectId)}><p>{state.copyText}</p></span>
        </div>}
      </form>
      {state.showCalculator && <AddNewCalculation projectId={state.projectId} kitchen={state.kitchenType} dbProject={state.project} />}

    </div>
  )
}

export default HomeScreen
